import {z} from 'zod';
import type {TranslationFunction} from 'src/types/language-support.ts';


const normalizeText = (text: string): string => {
  return text
    .normalize('NFKC') // Convert full-width & compatibility forms
    .replace(/[‘’‛‹›]/g, '\'') // Smart apostrophes → regular
    .replace(/[“”„‟«»]/g, '"') // Smart quotes → regular
    .replace(/[–—‐‒⁃−]/g, '-') // Dashes → regular hyphen
    .replace(/…/g, '...') // Ellipsis → three dots
    .replace(/\s+/g, ' ') // Collapse multiple spaces
    .trim(); // Remove leading/trailing spaces
};

export const getReasonSchema = (t: TranslationFunction) =>
  z
    .string()
    .min(1, t('Reason_is_required', 'Reason is required'))
    .transform(normalizeText)
    .transform((val: string) => val.trim())
    .refine(
      (val: string) => val.length <= 150 && val.length >= 5,
      t(
        'Reason_must_be_at_least_5_characters_long_and_at_most_150_characters_long',
        'Reason must be at least 5 characters long and at most 150 characters long',
      ),
    );
